<div class="hub-container">
  <button mat-button class="back-link" (click)="goBackToHub()">
    <mat-icon>arrow_back</mat-icon>
    Back to BI Reports
  </button>

  <h1 class="hub-title">Clinical Practice Guidelines (CPG) Reports</h1>
  <p class="hub-subtitle">Select a Clinical Practice Guideline (CPG) report below to view its dashboard.</p>

  @if (isLoading$ | async) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="loading-text">Loading reports...</p>
    </div>
  } @else {
    <div class="reports-grid">
      @for (report of (cpgReports$ | async); track report.reportId) {
        <div class="report-card">
          <div class="card-header">
            <div class="icon-container">
              <mat-icon>bar_chart</mat-icon>
            </div>
            <span class="report-title">{{ report.reportName }}</span>
          </div>
          <button mat-raised-button color="primary" (click)="openReport(report)">
            Open Dashboard
          </button>
        </div>
      }
    </div>
  }
</div>
